<template>
  <div>
    <div class="row animated-container">
      <div class="col-12 col-md-6">
        <img :src="imageUrl" class="w-100">
      </div>
      <div class="col-12 col-md-6 align-self-center">
        <h1 :style="headerStyles">{{header}}</h1>
        <div v-html="formattedText"></div>
        <div class="mt-3">{{signature}}</div>
        <div v-if="!isMultiInvitation" class="mt-3">
          {{ $t('thankYouPssst') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CustomerThanksPage',
  props: {
    imageUrl: String,
    header: String,
    text: String,
    signature: String,
    headerStyles: Object,
    isMultiInvitation: Boolean
  },
  computed: {
    formattedText(){
      return this.text.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
  }
}

</script>
